<template>
  <img :src="format(value)" :alt="name" v-if="isPicture" />
  <span v-else>{{ format ? format(value) : value }}</span>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TransactionPropertyComponent',
  components: {},
  props: {
    rawTransaction: {
      type: Object,
      default: () => {
        return {}
      },
    },
    reference: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    isMetaProperty: {
      type: Boolean,
      default: false,
    },
    isPicture: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: '',
    },
    format: {
      type: Function,
      default(value) {
        return value
      },
    },
  },
  data() {
    return {
      value: this.defaultValue,
      eventsIds: [],
    }
  },
  mounted() {
    this.setDefaultValue()
    this.loadProperty()
    const id = this.$Events.handleEvent(
      'transactions_updated',
      this.loadProperty,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
    this.unsubscribeToTransactionResponse()
  },
  methods: {
    setDefaultValue() {
      this.value = this.defaultValue
      if (!this.rawTransaction) return
      let value = null
      value = this.rawTransaction?.[this.name]
      if (this.isMetaProperty || value == undefined || value == null) {
        value = (this.rawTransaction?.metaData || {})[this.name]
      }
      if (value == null) value = this.defaultValue
      this.value = value
    },
    loadProperty() {
      if (this.$Commons.isEmpty(this.reference)) {
        this.setDefaultValue()
        return
      }

      this.unsubscribeToTransactionResponse()
      const { unsubscribe } = this.$Events.sendDataRequest(
        'transaction',
        this.onTransactionGot,
        { reference: this.reference },
      )
      this.unsubscribeToTransactionResponse = unsubscribe
    },
    unsubscribeToTransactionResponse() {},
    onTransactionGot(transaction) {
      this.$emit('dataAvailable', transaction)
      if (!transaction || transaction.reference !== this.reference) {
        this.setDefaultValue()
        return
      }
      if (this.$Commons.isEmpty(this.name)) return

      let value = null
      value = transaction[this.name]
      if (this.isMetaProperty || value == undefined || value == null)
        value = transaction.metaData[this.name]
      if (value == null || value == undefined) value = this.defaultValue
      this.value = value
    },
  },
  watch: {
    _props: {
      deep: true,
      handler() {
        this.setDefaultValue()
        this.loadProperty()
      },
    },
  },
})
</script>
